// LoginContext.js
import React, { createContext, useState, useContext } from "react";

const LoginContext = createContext();

export const LoginProvider = ({ children }) => {
  const [showLogin, setShowLogin] = useState(false);
  const [isFromLogin, setIsFromLogin] = useState(false);
  const [pswEditShow, setPswEditShow] = useState(false);
  const [registerShow, setRegisterShow] = useState(false);

  return (
    <LoginContext.Provider
      value={{
        showLogin,
        setShowLogin,
        isFromLogin,
        setIsFromLogin,
        pswEditShow,
        setPswEditShow,
        registerShow,
        setRegisterShow,
      }}
    >
      {children}
    </LoginContext.Provider>
  );
};

export const useLogin = () => useContext(LoginContext);
